import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12 13.25A5.625 5.625 0 1 0 12 2a5.625 5.625 0 0 0 0 11.25m5 1.25h-2.152a6.8 6.8 0 0 1-5.696 0H7a5 5 0 0 0-5 5v.625A1.875 1.875 0 0 0 3.875 22h16.25A1.875 1.875 0 0 0 22 20.125V19.5a5 5 0 0 0-5-5"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }